import {
  WorkPackageSearchByEnum,
  Scalars,
  WorkPackageSortByTerm,
  PersonaType,
  WorkPackageSearchByTerm,
  WorkPackageFilterByTerm,
  MilestoneFilterStatusFlag,
} from '@bechtel/types';
import { t } from '@lingui/macro';
import { startOfWeek, endOfWeek, addWeeks } from 'date-fns';

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export interface DrawerValuesProps {
  dateScope: WorkPackageFilterByTerm;
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  //assignedToMe: Scalars['Boolean'];
  searchBy: WorkPackageSearchByTerm[];
  filterByMilestoneTypes: string[];
  filterByMilestone: MilestoneFilterStatusFlag[];
  filterByUnassignedPersona: PersonaType[];
  filterByCommodity: string[];
  sortBy: WorkPackageSortByTerm;
  sortDir: SortDirection;
  searchScope: boolean;
}
export const initialDrawerValues: DrawerValuesProps = {
  startDate: startOfWeek(addWeeks(new Date(), -1), {
    weekStartsOn: 1, //TODO: Get from project config
  }),
  endDate: endOfWeek(addWeeks(new Date(), 2), {
    weekStartsOn: 1, //TODO: Get from project config
  }),
  searchBy: [{ type: WorkPackageSearchByEnum.WP_NUMBER }],
  filterByMilestoneTypes: [],
  filterByMilestone: [],
  filterByUnassignedPersona: [],
  filterByCommodity: [],
  sortBy: WorkPackageSortByTerm.WP_NUMBER,
  sortDir: SortDirection.DESC,
  searchScope: true,
  dateScope: WorkPackageFilterByTerm.ALL,
};

export interface DrawerProps {
  close: () => void;
  initialValues: DrawerValuesProps;
  onSubmit: (values: DrawerValuesProps) => void;
}

export const sortByList = [
  { id: 1, value: WorkPackageSortByTerm.WP_NUMBER, label: t`Work Package` },
  { id: 2, value: WorkPackageSortByTerm.START_DATE, label: t`Start Date` },
  { id: 3, value: WorkPackageSortByTerm.END_DATE, label: t`End Date` },
  { id: 4, value: WorkPackageSortByTerm.PERCENTAGE_COMPLETE, label: t`Percent Complete` },
];

export const searchScopeList = [
  { id: 1, value: true, label: t`Assigned to Me` },
  { id: 2, value: false, label: t`All Work Packages` },
];

export const searchByList = [
  {
    searchByTerm: { type: WorkPackageSearchByEnum.WP_NUMBER },
    label: t`Work Package Number`,
    scope: [true, false],
  },
  {
    searchByTerm: { type: WorkPackageSearchByEnum.COMMODITY },
    label: t`Commodity Tag`,
    scope: [true, false],
  },
  { searchByTerm: { type: WorkPackageSearchByEnum.PERSONA }, label: t`User Name`, scope: [true, false] },
  {
    searchByTerm: { type: WorkPackageSearchByEnum.STARTUP_SYSTEM_NUMBER },
    label: t`Startup System Number`,
    scope: [true, false],
  },
  {
    searchByTerm: { type: WorkPackageSearchByEnum.AREA_NUMBER },
    label: t`Area Number`,
    scope: [true, false],
  },
];

export const dateRangeScope = [
  { id: 1, value: WorkPackageFilterByTerm.ALL, label: t`All` },
  { id: 2, value: WorkPackageFilterByTerm.IN_3WLA, label: t`In 3WLA` },
  { id: 3, value: WorkPackageFilterByTerm.UNSCHEDULED, label: t`Unscheduled` },
  { id: 4, value: WorkPackageFilterByTerm.SCHEDULED, label: t`Scheduled` },
];
